// src/components/course/MobileSidebar.js
import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/solid';

const MobileSidebar = ({ isOpen, onClose, children }) => {
  return (
    <div
      className={`fixed inset-0 z-50 transition-opacity duration-300 ease-in-out lg:hidden ${
        isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
      }`}
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />

      {/* Sidebar Panel */}
      <div
        className={`
          relative flex flex-col w-72 max-w-[calc(100%-3rem)] h-full
          bg-background-primary shadow-xl border-r border-border
          transition-transform duration-300 ease-in-out
          ${isOpen ? 'transform-none' : '-translate-x-full'}
        `}
      >
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b border-border">
          <h2 className="text-lg font-semibold text-content-primary">Controls</h2>
          <button
            onClick={onClose}
            className="
              p-1 rounded-lg transition-colors duration-200
              hover:bg-border text-content-secondary hover:text-content-primary
            "
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        {/* Content */}
        <div className="p-4 flex-grow overflow-y-auto">{children}</div>
      </div>
    </div>
  );
};

export default MobileSidebar;
